import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

const Welcome = styled.div`
    margin: 0px 0px 10px 40px;
    font-size: 30px;
    font-weight: bold;
    color: ${props => props.color || props.theme.colors.primary};

    ${breakpoint('md', 'lg')`
        font-size: 25px;
    `}

    ${breakpoint('xs', 'md')`
        font-size: 20px;
    `}

`;

export default Welcome;



// WEBPACK FOOTER //
// ./src/components/organisms/home/Welcome.js